import { render } from "./MoneyRequestModal.vue?vue&type=template&id=40481b1b&scoped=true&ts=true"
import script from "./MoneyRequestModal.vue?vue&type=script&lang=ts"
export * from "./MoneyRequestModal.vue?vue&type=script&lang=ts"

import "./MoneyRequestModal.vue?vue&type=style&index=0&id=40481b1b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40481b1b"]])

export default __exports__